/*
 * The brand panel shows the merchant's logo. The backend does not have a single
 * agreed field for it yet, so we look through the places it could plausibly
 * arrive from — URL params first (they are the easiest thing for an integrator
 * to set), then whatever /form/init returned — and fall back to the merchant
 * name, and finally to the placeholder from the design.
 */

const LOGO_KEYS = ['logo', 'logo_url', 'merchant_logo', 'merchant_logo_url', 'shop_logo']
const NAME_KEYS = ['merchant', 'merchant_name', 'shop', 'shop_name']

function pick(keys, ...sources) {
  for (const source of sources) {
    if (!source) {
      continue
    }
    for (const key of keys) {
      const value = source[key]
      if (typeof value === 'string' && value.trim()) {
        return value.trim()
      }
    }
  }
  return ''
}

export function getMerchant(params, initData, paymentWidgetData) {
  return {
    logo: pick(LOGO_KEYS, params, paymentWidgetData, initData),
    name: pick(NAME_KEYS, params, paymentWidgetData, initData),
  }
}
